import {State} from 'redux/reducer';
import types, {serverKey} from './types';

export default {
   separator: (state: State) => state[serverKey].separator,
   [types.DOWNLOAD_CONNECTION_AUDIT_REPORT._FETCHING]: (state: State) =>
      state[serverKey][types.DOWNLOAD_CONNECTION_AUDIT_REPORT._FETCHING],
};
